import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "../hrmTour.css";

export function startPlanListTour() {
  const steps = [{ popover: { title: "Hướng dẫn nhanh", description: "Nộp kế hoạch, quản lý phê duyệt, theo dõi trạng thái — tương tự luồng Công việc trong HRM.", side: "over", align: "center" } }];
  const segments = [
    ['[data-tour="hrm-plans-header"]', "Tiêu đề", "Điều hướng nhanh và mở hướng dẫn.", "bottom"],
    ['[data-tour="hrm-plans-filter"]', "Bộ lọc", "Lọc theo chi nhánh, tháng, trạng thái; tạo kế hoạch mới.", "bottom"],
    ['[data-tour="hrm-plans-dashboard"]', "Tổng quan trạng thái", "Lọc nhanh theo chờ duyệt, đã duyệt, từ chối, nháp.", "bottom"],
    ['[data-tour="hrm-plans-sections"]', "Thẻ kế hoạch", "Mở chi tiết để xem nội dung và phê duyệt (nếu có quyền).", "top"],
    ['[data-tour="hrm-plans-table"]', "Bảng tra cứu", "Danh sách dạng bảng để đối chiếu nhanh.", "top"],
  ];
  for (const [selector, title, description, side] of segments) {
    const el = document.querySelector(selector);
    if (!el) continue;
    steps.push({ element: el, popover: { title, description, side } });
  }
  if (steps.length <= 1) return window.alert("Không tìm thấy vùng để chạy hướng dẫn.");
  driver({ showProgress: true, smoothScroll: true, popoverClass: "hrm-tour-popover", nextBtnText: "Tiếp", prevBtnText: "Trước", doneBtnText: "Xong", progressText: "Bước {{current}} / {{total}}", steps }).drive();
}
